import React from 'react';
import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { foundationApiRef, FoundationClient } from './api';

export const foundationPlugin = createPlugin({
  id: 'foundation',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: foundationApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new FoundationClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const FoundationPageExtension = foundationPlugin.provide(
  createRoutableExtension({
    name: 'FoundationPage',
    component: () =>
      import('./components/FoundationPage').then(m => m.FoundationPage),
    mountPoint: rootRouteRef,
  }),
);

export const FoundationPage = () => {
  const LazyComponent = React.lazy(() =>
    import('./components/FoundationPage').then(module => ({
      default: module.FoundationPage,
    })),
  );

  return (
    <React.Suspense fallback={<div>Loading Foundation...</div>}>
      <LazyComponent />
    </React.Suspense>
  );
};
